class IdesTable {
    constructor(config) {
        this.config = config;
        this.initLoadMore();
    }

    initLoadMore() {
        if (this.config && this.config.resultCount) {
            const idesCount = this.config.resultCount;

            $(".ides-table__table tbody tr.ides-row").css("display", "none");
            $(".ides-table-mobile .ides-table__card.ides-row").css("display", "none");

            window.Loadmore = function () {
                const cardsToShow = $(".ides-table-mobile .ides-table__card.ides-row:lt(" + idesCount + ")");
                const rowsToShow = $(".ides-table__table tbody tr.ides-row:lt(" + idesCount + ")");

                cardsToShow.css("display", "flex").removeClass("ides-row");
                rowsToShow.css("display", "").removeClass("ides-row");

                var totalVisibleRows = $(".ides-table-mobile .ides-table__card").not(".ides-row").length || $(".ides-table__table tbody tr").not(".ides-row").length;
                $(".Countresult").html(totalVisibleRows);


                if ($(".ides-table-mobile .ides-table__card.ides-row").length === 0 || $(".ides-table__table tbody tr.ides-row").length === 0) {
                    $(".ides-table__load-more").hide();
                }
            };
        } else {
            console.warn("idesConfig.resultCount is not defined or is invalid.");
        }
    }
}

$(document).ready(() => {
    new IdesTable(typeof idesConfig !== "undefined" ? idesConfig : null);
});


analytics.eventConfig.push({
    "target": ".ides-table",
    "events": [
        {
            "eventTarget": ".ides-table__action[data-ides-document-title]",
            "eventType": "click",
            "tags": {
                'event': 'file_download',
                'document_title': '',
                'document_type': 'pdf',
                'eventAction': 'Document Downloaded',
                'eventLabel': ''
            }
        }
    ]
});